export default "__VITE_ASSET__DipSFdzB__"